import React from "react";
import { Helmet } from "react-helmet-async";
import HeaderSection from "../common/header/header";
import Search from "../search/search";
import InFocusSection from "../../containers/infocus/infocus";
import LatestResearch from "../../containers/latestresearch/latestresearch";
import PopularSection from "../../containers/popularsection/popularsection";
import NewSection from "../../containers/newsection/newsection";
import SignUpSection from "../../components/signup/signup";
import FooterSection from "../common/footer/footer";
import NavBar from "../../components/navbar/navbar";
import PodcastChannelSelection from "../../components/podcastchannelselection/podcastchannelselection";
import * as navigation from "../../configs/navigation";
import ExternalContent from "../../containers/externalcontent/externalcontent";
import HeaderTabletSection from "../common/header/header.tablet";
import * as translate from "../../assets/translations/translations";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.showSearchComponent = this.showSearchComponent.bind(this);
  }

  showSearchComponent = (value) => {
    document.getElementById("searchText").focus();
  };

  togglePodcastsVisibility = () => {
    this.podcasts.togglePodcastsVisibility();
  };

  componentDidMount() {
    document.title = translate.strings.TR14;
    if (this.props.location.state && this.props.location.state.showPodcasts) {
      this.podcasts.open();
    }
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            Danske Bank Research - Financial Markets Insights & Analysis
          </title>
          <meta
            name="description"
            content="Danske Bank Research provides expert insights on financial markets, economics, credit analysis, and investment strategies. Stay informed with our latest research and publications."
          />
          <meta
            name="keywords"
            content="Danske Bank, research, financial markets, economics, credit analysis, investment, fixed income"
          />
          <link
            rel="canonical"
            href="https://research.danskebank.com/research/"
          />

          {/* Open Graph tags */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Danske Bank Research" />
          <meta
            property="og:description"
            content="Expert insights on financial markets, economics, and investment strategies from Danske Bank Research."
          />
          <meta
            property="og:url"
            content="https://research.danskebank.com/research/"
          />
          <meta property="og:site_name" content="Danske Bank Research" />

          {/* Twitter Card tags */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Danske Bank Research" />
          <meta
            name="twitter:description"
            content="Expert insights on financial markets, economics, and investment strategies."
          />
        </Helmet>
        <HeaderTabletSection
          history={this.props.history}
          togglePodcastsVisibility={this.togglePodcastsVisibility}
        />
        <HeaderSection
          showSearch={this.showSearchComponent}
          history={this.props.history}
        />
        <NavBar
          items={navigation.navInfo}
          togglePodcastsVisibility={this.togglePodcastsVisibility}
        />
        <Search homepage={true} />
        <PodcastChannelSelection
          ref={(podcasts) => {
            this.podcasts = podcasts;
          }}
        />
        <InFocusSection history={this.props.history} />
        <NewSection />
        <LatestResearch history={this.props.history} />
        <PopularSection history={this.props.history} />
        {/* <ExternalContent /> */}
        <SignUpSection />
        <FooterSection />
      </div>
    );
  }
}

export default HomePage;
